export const BRAND_NAME = 'Keyword.com';
export const DEFAULT_LANGUAGE = 'en (English)';
export const DEFAULT_REGION = 'google.com';
export const LAST_UPDATE_DATE_FORMAT = 'M dS, Y hh:mm';
export const MINIMAL_LEFT_SIDEBAR_WIDTH = 312;
export const TYPING_DEBOUNCE = 500;

// routes constants
export const PUBLIC_ROUTES = [
    'login',
    'thankYou',
    'emailVerification',
    'pdfView',
    'privacy',
    'forgotPassword',
    'setNewPassword',
    'shareViewkey',
    'shareViewkeyWithHash',
    'shareOfVoice',
    'shareOfVoiceWithHash',
    'shareKeywordsTable',
    'shareKeywordsTableWithHash',
    'signup',
    'PageNotFound',
    'ServerError',
];

// table-columns constants
export const KW_TABLE_COLUMNS = {
    GEO: ['near', 'gmb'],
    PERIODS: ['day', 'week', 'month', 'life'],
    GSC: ['clicks', 'impressions', 'ctr'],
    WITHOUT_I: ['kw', 'url', 'source', 'serpFeatures', 'searchIntents'],
    SIMPLE: ['day', 'week', 'month', 'life', 'seocomp', 'clicks', 'impressions', 'ctr', 'searchvolume', 'competition', 'cpc', 'visibility', 'estimated_traffic', 'timestamp', 'gpage', 'best', 'source'],
    STATIC: ['checkbox', 'kw'],
    PDF_EXCLUDE: ['checkbox'],
};

// other
export const VIRTUAL_LIST_ITEM_HEIGHT = 33; // should be sync with each line height to avoid table jumping

export const MS_PER_DAY = 1000 * 60 * 60 * 24;

export const MOBILE_WIDTH_RESOLUTION_PHONE = 960;

export const KW_TOTALS_SETTINGS = ['kwtotalsmaster', 'kwtotalsadmin', 'kwtotalsregular', 'kwtotalsview'];

export const apiCodes = {
    CRITICAL_ERROR: '0',

    UNAUTHORIZED: '401',
    ENDPOINT_FORBIDDEN: '403',

    MALFORMED_REQUEST: '500',
    MAINTENANCE: '503',

    GROUP_NOT_FOUND: '1001',
    GROUP_DELETED: '1002',
    VIEWKEY_NOT_FOUND: '1003',

    KEYWORD_NOT_FOUND: '1011',
    KEYWORD_DELETED: '1012',
    KEYWORD_UPDATED: '1013',

    ADDON_USER_NOT_FOUND: '1015',
    ADDON_USER_DELETED: '1016',
    ACCESS_NOT_ALLOWED: '1017',

    NOTE_NOT_FOUND: '1020',
    NOTE_DELETED: '1021',

    MODEL_VALIDATION_ERROR: '2000',
    REQUEST_VALIDATION_ERROR: '2001',

    USER_SUBSCRIPTION_ERROR: '2010',
    USER_ALREADY_EXISTS: '2011',
    USER_REGISTRATION_ERROR: '2012',
    WRONG_USER_PASSWORD: '2013',
    ADDON_USER_ALREADY_EXISTS: '2014',
    USER_SUBSCRIPTION_INACTIVE: '2015',
    USER_SUBSCRIPTION_CHANGE_PLAN_ERROR: '2016',

    SPARSE_FIELD_NOT_FOUND: '3000',

    TOKEN_NOT_FOUND: '115',
    USER_NOT_FOUND: '114'
};

// no case sensitive
export const FIRST_GROUP_NAME = 'My First Project';

// default metrics period (for dashboard overview table)
export const DEFAULTS_METRICS = {
    PROP: 'monthly',
    TITLE: 'for 30 days',
};

export const PROTOCOL_REGEXP = /^(?:(http[s]?|ftp))/;
export const PROTOCOL_REGEXP_WITH_SLASHES = /^(?:(ht|f)tp(s?)\:\/\/)?/;

export const MAX_KEYWORDS_COUNT_TO_FETCH_CHARTS = 50;

export const pdfExportParams = {
    selector: 'pdfWatcher',
    delay: 1000,
    per_page: 999999,
    page_width: '16.66in',
    page_height: '11.55in',
    margin_bottom: '0.31in',
    margin_top: '0in',
    layout_dpi: 72,
    element_to_convert: '.only-pdf',
};

export const TABLE_PARTS = {
    HEADER: 'HEADER',
    HEADER_ROW: 'HEADER_ROW',
    HEADER_COLUMN: 'HEADER_COLUMN',
    ROW: 'ROW',
    COLUMN: 'COLUMN',
    BODY: 'BODY',
    BODY_ROW: 'BODY_ROW',
    BODY_COLUMN: 'BODY_COLUMN',
    STATIC_BODY_COLUMN: 'STATIC_BODY_COLUMN',
    DYNAMIC_BODY_COLUMN: 'DYNAMIC_BODY_COLUMN',
}

export const SUBSCRIPTION_CHANGE_HEADER = 'x-change-type'

export const UPDATE_PLAN = 'UPDATE_PLAN';
export const UPGRADE_PLAN = 'UPGRADE_PLAN';
export const DOWNGRADE_PLAN = 'DOWNGRADE_PLAN';

export const REPORT_TYPE = {
    CSV: 0,
    PDF: 1,
    TEXT: 2,
};

export const REPORT_TYPE_KEY = ['CSV', 'PDF', 'TEXT'];

export const ENGINE_KEYS = {
    'se': 'desktop',
    'sem': 'mobile',
}

export const REPORT_GENERATION_STATUS = {
    PENDING: 0,
    IN_PROGRESS: 1,
    FAILED: 2,
    FILE_IS_READY: 3,
    FILE_SENT: 4,
    FILE_DOWNLOADED: 5,
};

export const KEYWORD_SOURCES = {
    API: { title: 'API', value: 1 },
    GSC: { title: 'GSC', value: 2 },
    MANUAL: { title: 'Manual', value: 3 },
    IMPORT: { title: 'Import', value: 4 },
};

export const GTM_EVENTS = {
    SUCCESSFULLY_SIGNED_UP: 'successfully_signed_up',
    SUCCESSFULLY_LOGGED_IN: 'successfully_logged_in',
    PROJECT_ADDED: 'd_add_project',
    CLICK_SHARE_OF_VOICE_TAB: 'd_share_of_voice_view',
    CLICK_EXPORT: 'd_export_project_data',
    CLICK_SHARE_VIEW_KEY: 'd_share_view_key',
    KEYWORDS_ADDED: 'd_add_kw',
    USE_FILTER: 'd_used_filter',
    CLICK_SUGGESTIONS_TAB: 'suggestions_tab_opened',
    KEYWORDS_FROM_SUGGESTIONS_ADD: 'keywords_from_suggestions_add',
    SUGGESTIONS_REMOVED: 'suggestions_removed',
    SUGGESTIONS_RESTORED: 'suggestions_restored',
};

export const CUSTOM_TRIAL_COUPONS = {
    'BRIGHTONSEO2023': 92,
    'SNIPLY-REVIEW': 92,
    'OMR-REVIEWS': 92,
    '3M200': 92,
    '1MKWD': 30,
    'DEFAULT': 14,
};

export const IMPORT_DATA_STEPS = {
    STEP_1: 1,
    STEP_2: 2,
    STEP_3: 3,
};

export const IMPORT_DATA_STATUSES = {
    MATCH_HEADINGS: 0,
    READY_TO_VALIDATE: 1,
    QUEUED: 2,
    IN_PROGRESS: 3,
    SUCCESS: 4,
    FAILED: 5,
};

export const API_DOCUMENTATION_LINK = 'https://docs.keyword.com';

export const CUSTOM_SUBDOMAINS = {
    'jettr20@gmail.com': 'https://skyhighagency.keyword.com',
    'seo@gamedaymenshealth.com': 'https://gamedaymenshealth.keyword.com',
    'info@seoconsult.ca': 'https://miromind.seranktracker.com',
    'nick@movermarketing.ai': 'https://ranking.movermarketing.ai',
    'richard@carsonclicks.co.uk': 'https://app.carsonclicks.co.uk'
};

export const BILLING_CYCLES = {
    monthly: 'monthly',
    annually: 'annually',
};

export const SMTP_PROVIDERS_FOR_SNIPER_LINK = {
    'google': 'https://mail.google.com/mail/u/email/#search/from%3A(no-reply%40keyword.com)+in%3Aanywhere+newer_than%3A1h',
    'g-suite': 'https://mail.google.com/mail/u/email/#search/from%3A(no-reply%40keyword.com)+in%3Aanywhere+newer_than%3A1h',
    'microsoft': 'https://outlook.live.com/mail/?login_hint=${encodeURIComponent(email)}',
    'yahoo': 'https://mail.yahoo.com/d/search/keyword=from%253Ano-reply%40keyword.com',
    'proton': 'https://mail.proton.me/u/0/all-mail#from=no-reply%40keyword.com',
};

export const PROJECT_ACTIVE_TABS = {
    keywords: 0,
    topPages: 1,
    competitions: 2,
    suggestions: 3,
};

export const PROJECT_MAIN_TABS = {
    keywords: 0,
    overview: 1,
    topPages: 2,
    suggestions: 3,
};

export const ONBOARDING_STATUSES = {
    previous: {
        HAVE_NOT: 1,
        XYZ: 2,
        MANUALLY: 3,
    },
    seoGoal: {
        IMPROVE_SEO: 1,
        SEND_REPORTS: 2,
        DISCOVER_COMPETITORS: 3,
        TRAKER_API: 4,
        OTHER: 5
    },
    source: {
        GOOGLE: 1,
        LINKEDIN_ADS: 2,
        SOCIAL_MEDIA: 3,
        BING: 4,
        WEBINAR: 5,
    },
    firstProject: null,
    finish: null,
};

export const INTEGRATED_SOCIAL_MEDIA_FOR_SIGN_IN = [
    'google', 'facebook', 'linkedin', 'microsoft'
];

export const DEFAULT_CURRENCY = {
    code: 'USD',
    symbol: '$',
};

export const IGNORE_CURRENCY = ['XDR'];

export const MIXPANEL_EVENT_CONSTANTS = {
    PROJECT_INITIATING_SOURCE: {
        ONBOARDING: 'onboarding',
        SIDE_PANEL: 'side_panel',
    },
    LEADING_SOURCE: {
        ACCOUNT: 'account',
        ONBOARDING: 'onboarding_popup',
        PROJECT_DASHBOARD: 'project_dashboard',
    },
    KEYWORD_TYPE: {
        'web': 'google_organic',
        'map': 'google_local_maps',
    },
};

export const CANCELATION_COUPON = 'SAVCHN20';

export const projectOverviewOptionsDefaultState = {
    project_metrics: {
        visible: true,
        order: 0,
        compared_date: null
    },
    keywords_in_top: {
        visible: true,
        order: 1,
        interval: null,
    },
    sov: {
        visible: true,
        order: 2,
        interval: null
    },
    distribution: {
        visible: true,
        order: 3,
        interval: null,
    },
    visibility: {
        visible: true,
        order: 4,
        interval: null,
    },
    estimated_traffic: {
        visible: true,
        order: 5,
        interval: null,
    },
    top_pages: {
        visible: true,
        order: 6,
        compared_date: null
    },
    organic_traffic_acquisition: {
        visible: true,
        order: 7,
        compared_date: null
    },
    serp_feature_performance: {
        visible: true,
        order: 8,
        compared_date: null
    },
    keywords_by_intent: {
        visible: true,
        order: 9,
        compared_date: null
    },
    average_rank: {
        visible: true,
        order: 10,
        interval: null,
    },
    visibility_and_estimated_traffic: {
        visible: false,
        order: 99,
        interval: null,
    },
};

export const oldOverviewUsers = [
    'famsemmler@t-online.de',
    'zamir.javer@mindshark.ca',
    'jonathan@justoctane.com'
];

export const googleIconBase64 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiByeD0iNCIgZmlsbD0iI0YxRjFGMSIvPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNDNfMTczKSI+CjxtYXNrIGlkPSJtYXNrMF80M18xNzMiIHN0eWxlPSJtYXNrLXR5cGU6bHVtaW5hbmNlIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIyIiB5PSIyIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiPgo8cGF0aCBkPSJNMTMuMTI1IDdIOFY5LjEyNUgxMC45NUMxMC42NzUgMTAuNDc1IDkuNTI1IDExLjI1IDggMTEuMjVDNi4yIDExLjI1IDQuNzUgOS44IDQuNzUgOEM0Ljc1IDYuMiA2LjIgNC43NSA4IDQuNzVDOC43NzUgNC43NSA5LjQ3NSA1LjAyNSAxMC4wMjUgNS40NzVMMTEuNjI1IDMuODc1QzEwLjY1IDMuMDI1IDkuNCAyLjUgOCAyLjVDNC45NSAyLjUgMi41IDQuOTUgMi41IDhDMi41IDExLjA1IDQuOTUgMTMuNSA4IDEzLjVDMTAuNzUgMTMuNSAxMy4yNSAxMS41IDEzLjI1IDhDMTMuMjUgNy42NzUgMTMuMiA3LjMyNSAxMy4xMjUgN1oiIGZpbGw9IndoaXRlIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF80M18xNzMpIj4KPHBhdGggZD0iTTIgMTEuMjVWNC43NUw2LjI1IDhMMiAxMS4yNVoiIGZpbGw9IiNGQkJDMDUiLz4KPC9nPgo8bWFzayBpZD0ibWFzazFfNDNfMTczIiBzdHlsZT0ibWFzay10eXBlOmx1bWluYW5jZSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMiIgeT0iMiIgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIj4KPHBhdGggZD0iTTEzLjEyNSA3SDhWOS4xMjVIMTAuOTVDMTAuNjc1IDEwLjQ3NSA5LjUyNSAxMS4yNSA4IDExLjI1QzYuMiAxMS4yNSA0Ljc1IDkuOCA0Ljc1IDhDNC43NSA2LjIgNi4yIDQuNzUgOCA0Ljc1QzguNzc1IDQuNzUgOS40NzUgNS4wMjUgMTAuMDI1IDUuNDc1TDExLjYyNSAzLjg3NUMxMC42NSAzLjAyNSA5LjQgMi41IDggMi41QzQuOTUgMi41IDIuNSA0Ljk1IDIuNSA4QzIuNSAxMS4wNSA0Ljk1IDEzLjUgOCAxMy41QzEwLjc1IDEzLjUgMTMuMjUgMTEuNSAxMy4yNSA4QzEzLjI1IDcuNjc1IDEzLjIgNy4zMjUgMTMuMTI1IDdaIiBmaWxsPSJ3aGl0ZSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazFfNDNfMTczKSI+CjxwYXRoIGQ9Ik0yIDQuNzVMNi4yNSA4TDggNi40NzVMMTQgNS41VjJIMlY0Ljc1WiIgZmlsbD0iI0VBNDMzNSIvPgo8L2c+CjxtYXNrIGlkPSJtYXNrMl80M18xNzMiIHN0eWxlPSJtYXNrLXR5cGU6bHVtaW5hbmNlIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIyIiB5PSIyIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiPgo8cGF0aCBkPSJNMTMuMTI1IDdIOFY5LjEyNUgxMC45NUMxMC42NzUgMTAuNDc1IDkuNTI1IDExLjI1IDggMTEuMjVDNi4yIDExLjI1IDQuNzUgOS44IDQuNzUgOEM0Ljc1IDYuMiA2LjIgNC43NSA4IDQuNzVDOC43NzUgNC43NSA5LjQ3NSA1LjAyNSAxMC4wMjUgNS40NzVMMTEuNjI1IDMuODc1QzEwLjY1IDMuMDI1IDkuNCAyLjUgOCAyLjVDNC45NSAyLjUgMi41IDQuOTUgMi41IDhDMi41IDExLjA1IDQuOTUgMTMuNSA4IDEzLjVDMTAuNzUgMTMuNSAxMy4yNSAxMS41IDEzLjI1IDhDMTMuMjUgNy42NzUgMTMuMiA3LjMyNSAxMy4xMjUgN1oiIGZpbGw9IndoaXRlIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMl80M18xNzMpIj4KPHBhdGggZD0iTTIgMTEuMjVMOS41IDUuNUwxMS40NzUgNS43NUwxNCAyVjE0SDJWMTEuMjVaIiBmaWxsPSIjMzRBODUzIi8+CjwvZz4KPG1hc2sgaWQ9Im1hc2szXzQzXzE3MyIgc3R5bGU9Im1hc2stdHlwZTpsdW1pbmFuY2UiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjIiIHk9IjIiIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiI+CjxwYXRoIGQ9Ik0xMy4xMjUgN0g4VjkuMTI1SDEwLjk1QzEwLjY3NSAxMC40NzUgOS41MjUgMTEuMjUgOCAxMS4yNUM2LjIgMTEuMjUgNC43NSA5LjggNC43NSA4QzQuNzUgNi4yIDYuMiA0Ljc1IDggNC43NUM4Ljc3NSA0Ljc1IDkuNDc1IDUuMDI1IDEwLjAyNSA1LjQ3NUwxMS42MjUgMy44NzVDMTAuNjUgMy4wMjUgOS40IDIuNSA4IDIuNUM0Ljk1IDIuNSAyLjUgNC45NSAyLjUgOEMyLjUgMTEuMDUgNC45NSAxMy41IDggMTMuNUMxMC43NSAxMy41IDEzLjI1IDExLjUgMTMuMjUgOEMxMy4yNSA3LjY3NSAxMy4yIDcuMzI1IDEzLjEyNSA3WiIgZmlsbD0id2hpdGUiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2szXzQzXzE3MykiPgo8cGF0aCBkPSJNMTQgMTRMNi4yNSA4TDUuMjUgNy4yNUwxNCA0Ljc1VjE0WiIgZmlsbD0iIzQyODVGNCIvPgo8L2c+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNDNfMTczIj4KPHJlY3Qgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAyKSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";

export const TRIAL_PACKAGE_ID = 'r1Czk9PT8bAh4mvEQO7U2w==';

export const GOOGLE_ADS_LANGUAGE_IDS = [
    {
        "label": "ar Arabic",
        "id": 1019,
        "code": "ar"
    },
    {
        "label": "bn Bengali",
        "id": 1056,
        "code": "bn"
    },
    {
        "label": "bg Bulgarian",
        "id": 1020,
        "code": "bg"
    },
    {
        "label": "ca Catalan",
        "id": 1038,
        "code": "ca"
    },
    {
        "label": "zh_CN Chinese (simplified)",
        "id": 1017,
        "code": "zh_CN"
    },
    {
        "label": "zh_TW Chinese (traditional)",
        "id": 1018,
        "code": "zh_TW"
    },
    {
        "label": "hr Croatian",
        "id": 1039,
        "code": "hr"
    },
    {
        "label": "cs Czech",
        "id": 1021,
        "code": "cs"
    },
    {
        "label": "da Danish",
        "id": 1009,
        "code": "da"
    },
    {
        "label": "nl Dutch",
        "id": 1010,
        "code": "nl"
    },
    {
        "label": "en English",
        "id": 1000,
        "code": "en"
    },
    {
        "label": "et Estonian",
        "id": 1043,
        "code": "et"
    },
    {
        "label": "tl Filipino",
        "id": 1042,
        "code": "tl"
    },
    {
        "label": "fi Finnish",
        "id": 1011,
        "code": "fi"
    },
    {
        "label": "fr French",
        "id": 1002,
        "code": "fr"
    },
    {
        "label": "de German",
        "id": 1001,
        "code": "de"
    },
    {
        "label": "el Greek",
        "id": 1022,
        "code": "el"
    },
    {
        "label": "gu Gujarati",
        "id": 1072,
        "code": "gu"
    },
    {
        "label": "iw Hebrew",
        "id": 1027,
        "code": "iw"
    },
    {
        "label": "hi Hindi",
        "id": 1023,
        "code": "hi"
    },
    {
        "label": "hu Hungarian",
        "id": 1024,
        "code": "hu"
    },
    {
        "label": "is Icelandic",
        "id": 1026,
        "code": "is"
    },
    {
        "label": "id Indonesian",
        "id": 1025,
        "code": "id"
    },
    {
        "label": "it Italian",
        "id": 1004,
        "code": "it"
    },
    {
        "label": "ja Japanese",
        "id": 1005,
        "code": "ja"
    },
    {
        "label": "kn Kannada",
        "id": 1086,
        "code": "kn"
    },
    {
        "label": "ko Korean",
        "id": 1012,
        "code": "ko"
    },
    {
        "label": "lv Latvian",
        "id": 1028,
        "code": "lv"
    },
    {
        "label": "lt Lithuanian",
        "id": 1029,
        "code": "lt"
    },
    {
        "label": "ms Malay",
        "id": 1102,
        "code": "ms"
    },
    {
        "label": "ml Malayalam",
        "id": 1098,
        "code": "ml"
    },
    {
        "label": "mr Marathi",
        "id": 1101,
        "code": "mr"
    },
    {
        "label": "no Norwegian",
        "id": 1013,
        "code": "no"
    },
    {
        "label": "fa Persian",
        "id": 1064,
        "code": "fa"
    },
    {
        "label": "pl Polish",
        "id": 1030,
        "code": "pl"
    },
    {
        "label": "pt Portuguese",
        "id": 1014,
        "code": "pt"
    },
    {
        "label": "pa Punjabi",
        "id": 1110,
        "code": "pa"
    },
    {
        "label": "ro Romanian",
        "id": 1032,
        "code": "ro"
    },
    {
        "label": "ru Russian",
        "id": 1031,
        "code": "ru"
    },
    {
        "label": "sr Serbian",
        "id": 1035,
        "code": "sr"
    },
    {
        "label": "sk Slovak",
        "id": 1033,
        "code": "sk"
    },
    {
        "label": "sl Slovenian",
        "id": 1034,
        "code": "sl"
    },
    {
        "label": "es Spanish",
        "id": 1003,
        "code": "es"
    },
    {
        "label": "sv Swedish",
        "id": 1015,
        "code": "sv"
    },
    {
        "label": "ta Tamil",
        "id": 1130,
        "code": "ta"
    },
    {
        "label": "te Telugu",
        "id": 1131,
        "code": "te"
    },
    {
        "label": "th Thai",
        "id": 1044,
        "code": "th"
    },
    {
        "label": "tr Turkish",
        "id": 1037,
        "code": "tr"
    },
    {
        "label": "uk Ukrainian",
        "id": 1036,
        "code": "uk"
    },
    {
        "label": "ur Urdu",
        "id": 1041,
        "code": "ur"
    },
    {
        "label": "vi Vietnamese",
        "id": 1040,
        "code": "vi"
    }
];
